import { withNamespaces } from "react-i18next";
import { Text, View, Link } from "@react-pdf/renderer";
import styles from "../../Styles";

const ContactRegistryInformation = ({ t, company }) => {
  const org = (() => {
    try {
      return company?.organizationData
        ? JSON.parse(company.organizationData)
        : null;
    } catch {
      return null;
    }
  })();

  const attr = org?.data?.attributes;
  const addr = attr?.address;
  const contact = attr?.contactInformation;
  const hr = attr?.identity?.handelsregister;

  // Build the "2.1 Address" rows
  const contactRegistryRows = [
    {
      title: "Address",
      details:
        [
          [addr?.street, addr?.houseNumber].filter(Boolean).join(" "),
          [addr?.postalCode, addr?.city].filter(Boolean).join(" "),
          addr?.country,
        ]
          .filter(Boolean)
          .join(", ") || "-",
    },
    {
      title: "Website",
      details:
        Array.isArray(contact?.websites) && contact.websites[0]
          ? contact.websites[0]
          : "-",
    },
    {
      title: "Phone",
      details:
        Array.isArray(contact?.phoneNumbers) && contact.phoneNumbers[0]
          ? contact.phoneNumbers[0]
          : "-",
    },
    {
      title: "Email",
      details:
        Array.isArray(contact?.emails) && contact.emails[0]
          ? contact.emails[0]
          : "-",
    },
    {
      title: "Registry Court",
      details: hr
        ? `${hr.court ?? "-"} (${hr.register ?? "-"} ${hr.number ?? "-"})`
        : "-",
    },
  ];

  return (
    <View style={styles.section}>
      {/* Section title */}
      <Text style={styles.sectionSeparator}>
        {`${t("2.")} ${t("Contact & Registry Information")}`}
      </Text>

      {/* 2.1 */}
      <Text style={styles.alphListItem}>{`2.1 ${t("Address")}`}</Text>

      <View style={styles.table}>
        {/* header row */}
        <View style={styles.tableRow}>
          <View style={styles.tableColHeader}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Title")}
            </Text>
          </View>

          <View style={{ ...styles.tableColHeader, ...styles.borderRightNone }}>
            <Text style={{ ...styles.tableCell, ...styles.fontBold }}>
              {t("Details")}
            </Text>
          </View>
        </View>

        {/* body rows */}
        {contactRegistryRows.map((d, i) => {
          const rowStyle = {
            ...styles.tableRow,
            ...(i === contactRegistryRows.length - 1
              ? styles.tableLastRow
              : {}),
          };

          const isWebsite =
            d.title === "Website" && d.details && d.details !== "-";
          const isEmail = d.title === "Email" && d.details && d.details !== "-";

          return (
            <View style={rowStyle} key={i}>
              <View style={styles.tableCol}>
                <Text style={styles.tableCell}>{t(d.title)}</Text>
              </View>

              <View style={{ ...styles.tableCol, ...styles.borderRightNone }}>
                {/* Make website/email clickable like the screenshot style */}
                {isWebsite ? (
                  <Link src={d.details} style={styles.tableCell}>
                    {d.details}
                  </Link>
                ) : isEmail ? (
                  <Link src={`mailto:${d.details}`} style={styles.tableCell}>
                    {d.details}
                  </Link>
                ) : (
                  <Text style={styles.tableCell}>{d.details ?? "-"}</Text>
                )}
              </View>
            </View>
          );
        })}
      </View>
    </View>
  );
};

export default withNamespaces()(ContactRegistryInformation);
